import { useMutation, useQueryClient } from "@tanstack/react-query";

import { invalidateSkillCollectionVersionQueries } from "./cache-utils";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface MoveSkillCollectionLabelParams {
  workspaceId: number;
  collectionId: string;
  labelId: number;
  targetVersionId: string;
}

export const useMoveSkillCollectionLabel = () => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ labelId, targetVersionId }: MoveSkillCollectionLabelParams) => {
      const res = await fetch(ENDPOINTS.skill_collections.label(labelId), {
        method: "PATCH",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          skill_collection_version_id: targetVersionId,
        }),
      });
      return handleResponse(res);
    },
    onSuccess: (_, variables) => {
      invalidateSkillCollectionVersionQueries(queryClient, variables);
    },
  });
};
